<div class="customized-suggestions">
  <input
    #searchInput
    [type]="props.type"
    [formControl]="formControl"
    [formlyAttributes]="field"
    class="form-control field-focus"
    [ngClass]="props.inputClass"
    [attr.data-testing-id]="field.key"
    (keyup)="searchSuggest($event.target)"
    (blur)="blur()"
    (keydown.esc)="blur()"
    (keydown)="focus()"
    (keydown.arrowleft)="selectSuggestedTerm(-1)"
    (keydown.arrowright)="selectSuggestedTerm(-1)"
    (keydown.arrowdown)="selectSuggestedTerm(activeIndex + 1)"
    (keydown.arrowup)="selectSuggestedTerm(activeIndex - 1)"
    (keydown.enter)="$event.preventDefault(); submitSearch(searchInput.value)"
  />

  @if (productSearchResults$ | async; as results) { @if (results.length && searchInput.value.length > 2 && inputFocused)
  {
  <ul class="input-box overflow-auto p-0 border">
    @for (result of results; track result; let liIndex = $index) {
    <li
      [class.active-suggestion]="activeIndex === liIndex"
      (mousedown)="submitSearch(result.id)"
      (mouseenter)="activeIndex = liIndex"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-4 p-0 pl-2">
            <img loading="lazy" class="product-image" [src]="getImageUrl(result)" />
            <!-- <ish-product-image imageType="S"></ish-product-image> -->
            <img />
          </div>
          <div class="col-8 d-flex align-items-center">
            <button class="result_term" type="button" [innerHTML]="result?.term"></button>
          </div>
        </div>
      </div>
    </li>
    }
  </ul>
  } }
</div>
